import { ExternalLinkOutlineIcon } from '@web-for-marketing/react-ui';
import React from 'react';

export function NewTabIcon(props: React.SVGProps<SVGSVGElement>): React.ReactElement {
    return <ExternalLinkOutlineIcon height={15} width={15} data-testid='externalIcon' {...props} />;
}
